import DarkButton from '@/components/ui/Buttons/SecondaryButton'
import Loader from '@/components/ui/loader'
import { useToast } from '@/context/ToastContext'
import { useMobiApi } from '@/services/mobi-api'
import { GetEsimDevicesRes } from '@/services/mobi-api/info/types'
import { IMG_URL } from '@/utils/constants'
import useIntl from '@/utils/intl'
import { FormControl, MenuItem, Select } from '@mui/material'
import Image from 'next/image'
import React, { FunctionComponent, useEffect, useState } from 'react'

interface Props {
  onClick: () => void
}
const ITEM_HEIGHT = 55
const ITEM_PADDING_TOP = 8

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
}

const EsimInfo: FunctionComponent<Props> = ({ onClick }) => {
  const { translate } = useIntl()
  const { showError } = useToast()
  const { info } = useMobiApi()
  const [data, setData] = useState<GetEsimDevicesRes | undefined>()

  useEffect(() => { void fetchData() }, [])
  const fetchData = async (): Promise<void> => {
    try {
      const res = await info.getEsimDevices()
      setData(res)
    } catch (e) {
      console.error(e)
      showError(translate('error'))
    }
  }

  if (data === undefined) {
    return <div className='w-full h-96 flex items-center justify-center'><Loader /></div>
  }
  return (
    <div className='bg-surfaceInverse rounded-xl md:shadow w-full h-full md:h-[75vh] md:w-fit flex flex-col justify-start overflow-auto relative'>
      <div className='py-6 px-4 md:p-8 flex flex-col gap-4 flex-grow overflow-auto'>
        <span className='text-textHigh font-bold'>{translate('sim.select_device')}</span>
        <FormControl
          sx={{
            mt: 3,
            '& label.Mui-focused': {
              color: '#262626'
            },
            '& fieldset': {
              borderRadius: '12px',
              borderColor: '#D6D6D6'
            },
            '& .MuiOutlinedInput-root': {
              '&.Mui-focused fieldset': {
                borderColor: '#D6D6D6'
              }
            }
          }} className='w-full bg-surfaceLow rounded-lg'
        >
          {/* <InputLabel className='px-1'>Ухаалаг хэрэгсэл</InputLabel> */}
          <Select
            name='selectedCityId'
            className='rounded-lg text-textHigh md:w-96'
            MenuProps={MenuProps}
          >
            {data.devices.map((item, i) => (
              <MenuItem key={i} className='bg-surfaceInverse text-textHigh' value={i}>{item}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <div className='flex items-start gap-3 border border-[#F4A610] bg-[#FEFCF5] rounded-lg p-3 mt-4 md:w-96'>
          <Image draggable={false} width={30} height={30} src={IMG_URL + '/uploads/icons/info.svg'} alt='!' className='border-2 border-[#FEF3C7] rounded-full' />
          <div className='flex flex-col gap-2'>
            <span className='text-sm text-[#78350F] font-medium'>{translate('sim.esim.guide')}</span>
            <span className='text-[#78350F] text-sm font-bold'>iPhone: {data.settings.iphone}</span>
            <span className='text-[#78350F] text-sm font-bold'>{translate('others')}: {data.settings.other}</span>
          </div>
        </div>
      </div>
      <div className='fixed md:sticky bottom-0 right-0 left-0 z-50 md:p-6 p-4 border-t bg-surfaceInverse border-secondaryMidStroke'>
        <DarkButton fullwidth onClick={() => onClick()}>{translate('continue')}</DarkButton>
      </div>
    </div>
  )
}
export default EsimInfo
